<div class="surface-section p-3">
    <p-toast [life]="5000" />
    <p-confirmdialog />
    <!-- Company Info Header -->
    <div class="company-info-header">
        <app-company-header 
            [isLoading]="isLoading" 
            (refreshClicked)="refreshData()">
        </app-company-header>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading && !dataLoaded" class="loading-container">
        <div class="text-center">
            <i class="pi pi-spin pi-spinner text-4xl text-primary mb-3"></i>
            <p class="text-lg">{{ getLoadingMessage() }}</p>
        </div>
    </div>

    <!-- No Company Selected State -->
    <div *ngIf="!currentCompany && !isLoading" class="no-company-container">
        <i class="pi pi-spinner pi-spin text-6xl text-color-secondary mb-4"></i>
        <p class="text-color-secondary">Loading company data...</p>
    </div>

    <div *ngIf="currentCompany && (dataLoaded || !isLoading)" class="linkedin-content">

        <!-- Header section using PrimeFlex -->
        <div class="page-header flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-4">
            <div class="header-left flex flex-column">
                <h1 class="m-0">LinkedIn Outreach</h1>
                <span class="mt-1">Create and manage LinkedIn outreach campaigns</span>
            </div>
            <div>
                <button pButton pRipple icon="pi pi-plus" label="Import Prospects"
                    class="p-button p-button-secondary mt-3 md:mt-0" (click)="importLeads()"></button>
                <button *ngIf="showSequences" pButton pRipple icon="pi pi-plus" label="New Sequence"
                    class="p-button-primary p-button mt-3 ml-2 md:mt-0" (click)="newSequence()"></button>
                <button *ngIf="showTemplates" pButton pRipple icon="pi pi-plus" label="New Template"
                    class="p-button-primary p-button mt-3 ml-2 md:mt-0" (click)="newTemplate()"></button>
            </div>
        </div>
        <div class="mb-5">
            <p-tabMenu [model]="tabs" [activeItem]="activeTab" (activeItemChange)="onTabChange($event)"></p-tabMenu>
        </div>

        <div class="card p-0" *ngIf="showSequences">
            <p-table [value]="sequences" [loading]="sequencesLoading" styleClass="p-datatable-sm"
                responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-left font-medium text-color-secondary">Sequence Name</th>
                        <th class="text-left font-medium text-color-secondary">Status</th>
                        <th class="text-center font-medium text-color-secondary">Steps</th>
                        <th class="text-center font-medium text-color-secondary">Connections</th>
                        <th class="text-center font-medium text-color-secondary">Responses</th>
                        <th class="text-left font-medium text-color-secondary">Created</th>
                        <th class="text-center font-medium text-color-secondary">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-sequence>
                    <tr>
                        <td class="text-900 font-medium">{{ sequence.name }}</td>
                        <td>
                            <p-tag [value]="sequence.status" [severity]="getSeverity(sequence.status)"></p-tag>
                        </td>
                        <td class="text-center">{{ sequence.numSteps || 0 }}</td>
                        <td class="text-center">{{ sequence.metrics?.connectionsAccepted || 0 }}</td>
                        <td class="text-center">{{ sequence.metrics?.totalMessageReplies||0 }}</td>
                        <td>{{ sequence.createdAt | date:'M/d/yyyy' }}</td>
                        <td>
                            <div class="flex justify-content-center gap-2">
                                <button pButton pRipple icon="pi pi-play" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    (click)="startSequence(sequence)"
                                    *ngIf="sequence.status=='paused' || sequence.status=='draft'" pTooltip="Start"
                                    tooltipPosition="top"></button>
                                <button pButton pRipple icon="pi pi-pause" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    (click)="pauseSequence(sequence)" *ngIf="sequence.status=='active'" pTooltip="Pause"
                                    tooltipPosition="top"></button>
                                <button pButton pRipple icon="pi pi-eye" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    (click)="navigateToDetails(sequence)"></button>
                                <button pButton pRipple icon="pi pi-chart-bar" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    (click)="navigateToMetrics(sequence)"></button>
                                <button pButton pRipple icon="pi pi-trash"
                                    class="p-button-outlined p-button-secondary p-button-rounded p-button-sm" (click)="deleteSequence(sequence)"
                                    pTooltip="Delete" tooltipPosition="top"
                                    *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"
                                    [style.display]="sequence.status!='deleted' ? 'inline-flex' : 'none'"></button>
                                <button *ngIf="!sequence.providerListId && sequence.status!='deleted' " pButton pRipple
                                    icon="pi pi-sync" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    pTooltip="Sync the leads list with your LinkedIn platform" tooltipPosition="top"
                                    (click)="syncLeadList(sequence)"
                                    [disabled]="sequence.status === 'in-process' ||  sequence.status=='in process'"></button>

                                <!-- <button *ngIf="hasWebHook(sequence)  && sequence.status!='deleted'" pButton pRipple
                                    icon="pi pi-bolt" class="p-button-text p-button-rounded"
                                    (click)="createWebhook(sequence)" pTooltip="Enable Messaging Webhooks"
                                    tooltipPosition="top"></button> -->
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="text-center">
                            <div class="py-4">
                                <i class="pi pi-list text-4xl text-color-secondary mb-3"></i>
                                <p class="text-color-secondary">No sequences found for this company.</p>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Templates Table -->
        <div class="card p-0" *ngIf="showTemplates">
            <p-table [value]="templates" [loading]="templatesLoading" styleClass="p-datatable-gridlines p-datatable-sm"
                [paginator]="true" [rows]="10" *ngIf="templates.length>0">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Template Name</th>
                        <th>Type</th>
                        <th>Last Modified</th>
                        <th>Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-template>
                    <tr>
                        <td>{{template.name}}</td>
                        <td>{{template.type}}</td>
                        <td>{{template.updatedAt | date:'MM-dd-yyyy'}}</td>
                        <td>
                            <div class="action-buttons">
                                <button pButton pRipple icon="pi pi-pencil" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    (click)="editTemplate(template)" pTooltip="Edit" tooltipPosition="top"
                                    *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"></button>
                                <button pButton pRipple icon="pi pi-copy" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    pTooltip="Duplicate" tooltipPosition="top"
                                    (click)="copyTemplate(template)"
                                    *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-outlined p-button-secondary p-button-rounded p-button-sm"
                                    pTooltip="Delete" tooltipPosition="top" (click)="deleteTemplate(template)"
                                    *appRequiresCapability="'sequence_management'; integration: selectedIntegration; mode: 'disable'"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">No templates found.</td>
                    </tr>
                </ng-template>
            </p-table>
            <div class="icon-container" *ngIf="templates.length==0 && !templatesLoading">
                <div class="text-center py-5">
                    <i class="pi pi-file text-4xl text-color-secondary mb-3"></i>
                    <p class="text-color-secondary">No templates available for this company.</p>
                </div>
            </div>
        </div>

        <!-- Prospects List -->
        <div *ngIf="showLeads">
            <p-dataView #dv [value]="prospects" [layout]="prospectLayout" *ngIf="prospects.length > 0">
                <ng-template pTemplate="grid" #grid let-prospects>
                    <div class="grid">
                        <div *ngFor="let prospect of prospects" class="col-12 md:col-6 lg:col-4 xl:col-3">
                            <div class="prospect-list-card" pTooltip="{{getTooltipContent(prospect)}}"
                                tooltipStyleClass="linkedin-sender-tooltip" tooltipPosition="top" [escape]="false">
                                <div class="card-content">
                                    <div class="card-title-section">
                                        <h3 class="list-title">{{prospect.name}}</h3>
                                        <button pButton icon="pi pi-users custom-icon-size text-2xl"
                                            class="p-button-rounded pi-lg p-button-text p-button-plain"></button>
                                    </div>
                                    <p class="prospect-count">{{prospect.count}} prospects</p>
                                    <p class="creation-date">Created on {{prospect.updatedAt | date:'M/d/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>

            <!-- Empty state for prospects -->
            <div *ngIf="prospects.length === 0 && !isLoading" class="text-center py-5">
                <i class="pi pi-users text-4xl text-color-secondary mb-3"></i>
                <h3 class="text-color">No Prospects Available</h3>
                <p class="text-color-secondary">Import prospects to get started with LinkedIn outreach.</p>
                <button pButton pRipple icon="pi pi-plus" label="Import Prospects" class="p-button-primary mt-3"
                    (click)="importLeads()"></button>
            </div>
        </div>

        <!-- New Sequence -->
        <div *ngIf="showNewSequence">
            <app-new-linkedin-sequence [completeCallback]="completeNewSequence" [cancelCallback]="cancelNewSequence"
                [templates]="linkedInTemplates" [leadsLists]="availableProspects"
                [excludeLists]="prospects" [companyId]="currentCompany!.companyId"></app-new-linkedin-sequence>
        </div>

        <!-- New Template Section -->
        <div *ngIf="showNewTemplate">
            <app-new-linkedin-template [completeCallback]="completeNewTemplate" [cancelCallback]="cancelNewTemplate"
                [template]="editingTemplate" [isCopyTemplate]="isCopyTemplate"></app-new-linkedin-template>
        </div>

        <!-- Import Leads Dialog -->
        <app-prospect-import-dialog [(visible)]="showImportDialog" (fileUploaded)="onProspectsImported($event)" [company]="currentCompany"
            (cancel)="onImportCancelled()" [platform]="'linkedin'">
        </app-prospect-import-dialog>
    </div>
</div>